module.exports = __webpack_public_path__ + "static/media/list.dd609d0b.svg";